<template>
  <v-card tile>
    <v-container
      style="
        min-height: 100vh;
        height: 100%;
        max-width: 1400px;
        margin: auto;
        padding-left: 60px;
      "
    >
      <booking-admin-form-multi
        :selectedDay="selectedDay"
        :dialogFormMulti="dialogFormMulti"
        :onOrderCreatePage="true"
        :amoId="amoId"
        @close-dialog="dialogFormMulti = false"
        @visible-alert="alert = true"
      ></booking-admin-form-multi>
      <OrderInformationModal
        :alert="alert"
        @close-alert="reloadForm"
      ></OrderInformationModal>
    </v-container>
  </v-card>
</template>

<script>
import BookingAdminFormMulti from "@/components/BookingAdminFormMulti.vue";
import store from "@/store";
import OrderInformationModal from "@/components/OrderInformationModal";

export default {
  name: "CreatePage",

  beforeRouteEnter: async (to, from, next) => {
    await store.dispatch("loadLocation", to.params.location_id);
    next();
  },

  components: {
    BookingAdminFormMulti,
    OrderInformationModal,
  },

  data() {
    return {
      selectedDay: new Date(),
      dialogFormMulti: null,
      alert: false,
      amoId: null,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.dialogFormMulti = true;
    });
    this.amoId = this.$route.query.amo_id;
  },

  methods: {
    reloadForm() {
      this.alert = false;
      this.$nextTick(() => {
        this.dialogFormMulti = true;
      });
    },
  },
};
</script>
